import { RootState, AppThunk } from '../../store'
import configuration from '../../../configuration'
import { push } from 'connected-react-router'
import { request } from '../../../common/utility/fetch'
import {
  AuthState,
  LoginParams,
  User,
  loginPending,
  loginSuccess,
  loginFailure,
  logoutSuccess,
  clearError,
  setRedirectPath,
  verifySessionPending,
  verifySessionSuccess,
  verifySessionFailure,
  initialState,
} from '.'

export const login =
  (args: LoginParams): AppThunk =>
  async (dispatch, getState) => {
    dispatch(loginPending(true))
    const state = getState() as RootState
    try {
      const response = await loginUser(args)
      dispatch(loginSuccess(response))
      dispatch(push(state.auth.redirectPath))
    } catch (error: any) {
      const errorMessage = error.message
        ? error.message
        : 'An unknown error occurred'
      dispatch(loginFailure(errorMessage))
    } finally {
      if (state.auth.isLoggedIn) {
        dispatch(setRedirectPath(initialState.redirectPath))
      }
    }
  }

export const reAuthExternalUser =
  (token: string): AppThunk =>
  async (dispatch) => {
    dispatch(verifySessionPending(true))
    try {
      const response = await verifySession(token)
      dispatch(verifySessionSuccess(response))
    } catch (error: any) {
      dispatch(verifySessionFailure())
    }
  }

export const logout = () => (dispatch: any) => dispatch(logoutSuccess())

export const resetError = () => (dispatch: any) => dispatch(clearError())

export const redirectToPath = (path: string) => (dispatch: any) =>
  dispatch(setRedirectPath(path))

const setLoginError = (
  args: LoginParams,
  message: string,
): AuthState['error'] =>
  !!args.phone && message === 'Invalid credentials'
    ? 'Invalid phone number or PIN'
    : !!args.email && message === 'Invalid credentials'
    ? 'Invalid email or password'
    : message

export const verifySession = async (authToken: string): Promise<User> => {
  const baseUrl = configuration.realmApiUrl
  const endpoint = '/users/me'
  const method = 'GET'
  const response = await request({
    baseUrl,
    endpoint,
    method,
    authToken,
  })
  const result = await response.json()

  return response.ok
    ? ({ ...result, auth_token: authToken } as User)
    : Promise.reject(new Error(result.error as AuthState['error']))
}

const loginUser = async (args: LoginParams): Promise<User> => {
  const baseUrl = configuration.realmApiUrl
  const endpoint = '/login'
  const method = 'POST'
  const body = JSON.stringify({
    email_or_phone: args.phone || args.email,
    password_or_pin: args.pin || args.password,
  })
  const response = await request({ baseUrl, endpoint, method, body })
  const result = await response.json()

  return response.ok
    ? (result as User)
    : Promise.reject(
        new Error(setLoginError(args, result.message as AuthState['error'])),
      )
}
